export default __webpack_public_path__ + "static/media/M21.a8433de6.jpg";